// extracted by mini-css-extract-plugin
module.exports = {"subActions":"makeItem_subActions__Nx35s","compact":"makeItem_compact__NUcGz","transferIdsButton":"makeItem_transferIdsButton__x5k_H"};